/* Teckel Paris — bouton panier des cartes produit
   Ajoute la variante au panier sans quitter la page, puis met à jour le compteur du panier du thème. */
(function () {
  if (window.mcCardReady) return;
  window.mcCardReady = true;

  var ADDED_MS = 1400;

  function updateCartBubble(sections) {
    if (!sections || !sections['cart-icon-bubble']) return;
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var source = doc.querySelector('.shopify-section') || doc.body;
    bubble.innerHTML = source.innerHTML;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mc-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    button.setAttribute('aria-busy', 'true');

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.getAttribute('data-mc-add')), quantity: 1 }],
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        updateCartBubble(data.sections);
        button.classList.add('is-added');
        var label = button.getAttribute('aria-label');
        button.setAttribute('aria-label', 'Ajouté au panier');
        setTimeout(function () {
          button.classList.remove('is-added');
          button.setAttribute('aria-label', label);
        }, ADDED_MS);
        document.dispatchEvent(new CustomEvent('mc:cart-added', { detail: data }));
      })
      .catch(function (error) {
        // Produit plus disponible ou autre erreur : on envoie vers la fiche produit
        var card = button.closest('.mc-card');
        var link = card && card.querySelector('.mc-card__view');
        if (link) window.location.href = link.href;
        console.warn('Teckel Paris – ajout au panier impossible', error);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });
})();
